var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.tituloModal } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoSwitch },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.serie.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoSerie,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLectura
                                },
                                on: { change: _vm.cambioEstadoSerieSwitch },
                                model: {
                                  value: _vm.formFields.serie.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.serie, "value", $$v)
                                  },
                                  expression: "formFields.serie.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.gps.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoGps,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLectura
                                },
                                on: { change: _vm.cambioEstadoGpsSwitch },
                                model: {
                                  value: _vm.formFields.gps.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.gps, "value", $$v)
                                  },
                                  expression: "formFields.gps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-divider", { attrs: { inset: "" } }),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.vehiculo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoVehiculo,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoVehiculoSwitch },
                                model: {
                                  value: _vm.formFields.vehiculo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.vehiculo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.vehiculo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.marca.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoMarca,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLecturaVehiculo
                                },
                                on: { change: _vm.cambioEstadoMarcaSwitch },
                                model: {
                                  value: _vm.formFields.marca.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.marca, "value", $$v)
                                  },
                                  expression: "formFields.marca.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.modelo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoModelo,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLecturaVehiculo
                                },
                                on: { change: _vm.cambioEstadoModeloSwitch },
                                model: {
                                  value: _vm.formFields.modelo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.modelo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.modelo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.anio.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoAnio,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLecturaVehiculo
                                },
                                on: { change: _vm.cambioEstadoAnioSwitch },
                                model: {
                                  value: _vm.formFields.anio.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.anio, "value", $$v)
                                  },
                                  expression: "formFields.anio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.tipo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoTipo,
                                  readonly: _vm.modoVer,
                                  disabled: _vm.soloLecturaVehiculo
                                },
                                on: { change: _vm.cambioEstadoTipoSwitch },
                                model: {
                                  value: _vm.formFields.tipo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.tipo, "value", $$v)
                                  },
                                  expression: "formFields.tipo.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-layout",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.muestraAlertaMantencionPorVencer ||
                                _vm.muestraAlertaMantencionVencida,
                              expression:
                                "\n              muestraAlertaMantencionPorVencer ||\n                muestraAlertaMantencionVencida\n            "
                            }
                          ],
                          attrs: { row: "", wrap: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("BuscadorOperacionCrud", {
                                attrs: {
                                  filter:
                                    _vm.gridApiPlanes &&
                                    _vm.gridApiPlanes.setQuickFilter.bind(
                                      _vm.gridApiPlanes
                                    )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }